// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3088q","selected":"Chip_selected__2ICL8"};